export default function Header() {
    return (
<div className="bg-white shadow-md">
 <div className="container mx-auto p-2">
 <h1 className="text-2xl font-bold text-blue-900"><a href="/">Zuddlo</a></h1>
 </div>   
</div>
    );
  }